import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import {
  getAllMessages,
  getMessage,
  getMessageLogs,
  getAllMessageLogs,
  getPriorities,
} from "./utils";

// Create the context
const MessagesContext = createContext();

// Create a provider component
export const MessagesProvider = ({ children }) => {
  const [reload, setReload] = useState(true);
  const [messages, setMessages] = useState(null);
  const [message, setMessage] = useState();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedMessageLog, setSelectedMessageLog] = useState(null);
  const [selectedMessageLogs, setSelectedMessageLogs] = useState(null);
  const [viewAllLogs, setViewAllLogs] = useState(false);
  const [authenticationChecked, setAuthenticationChecked] = useState("Success");
  const [filters, setFilters] = useState({
    activeOnly: false,
    includeIncidentMessages: true,
  });

  const [filterValues, setFilterValues] = useState({
    activeOnly: filters.activeOnly,
    includeIncidentMessages: filters.includeIncidentMessages,
  });

  useEffect(() => {
    if (selectedMessage !== null && selectedMessage.id !== null)
      setMessage(
        messages.filter(
          (eachMessage) => eachMessage.id === selectedMessage.id,
        )[0],
      );
  }, [selectedMessage]);

  useEffect(() => {
    getPriorities((data) =>
      setFilterValues((prev) => ({ ...prev, priorities: data })),
    );
  }, []);

  const loadMessages = useCallback(() => {
    getAllMessages(
      filters.activeOnly,
      filters.includeIncidentMessages,
      setMessages,
      setAuthenticationChecked,
    );
  }, [filters]);

  useEffect(() => {
    loadMessages();
    setReload(false);
  }, [loadMessages, reload]);

  useEffect(() => {
    if (null === selectedMessageLog) {
      setSelectedMessageLogs(null);
    } else {
      getMessageLogs(selectedMessageLog.id, setSelectedMessageLogs);
    }
  }, [selectedMessageLog]);

  return (
    <MessagesContext.Provider
      value={{
        message,
        messages,
        filters,
        selectedMessage,
        selectedMessageLog,
        filterValues,
        selectedMessageLogs,
        viewAllLogs,
        setSelectedMessageLog,
        setSelectedMessage,
        setFilters,
        setMessages,
        setMessage,
        setReload,
        setViewAllLogs,
        authenticationChecked,
        setAuthenticationChecked,
      }}
    >
      {children}
    </MessagesContext.Provider>
  );
};

// Custom hook to use the AnnouncementsContext
export const useMessages = () => {
  const context = useContext(MessagesContext);
  if (!context) {
    throw new Error("useMessages must be used within an MessagesProvider");
  }
  return context;
};
